import React from 'react';
import '../styles/HeroImage.css';

interface HeroImageProps {
  className?: string;
  width?: string;
  height?: string;
  showOverlay?: boolean;
}

/**
 * A static hero image component that displays a magical bedtime scene
 * This replaces the previous animated GeneratedImage component
 */
const HeroImage: React.FC<HeroImageProps> = ({ 
  className = '', 
  width = '100%', 
  height = 'auto',
  showOverlay = true
}) => {
  return (
    <div className={`hero-image-container ${className}`} style={{ width, height }}>
      <img 
        src={`${process.env.PUBLIC_URL}/assets/images/bedtime-story-hero.jpg`}
        alt="A child's imagination coming to life with magical creatures and floating books" 
        className="hero-static-image"
      />
      {showOverlay && (
        <div className="image-overlay">
          <div className="overlay-gradient"></div>
        </div>
      )}
    </div>
  );
};

export default HeroImage; 